import Vue from 'vue'
import axios from 'axios';

//sistema

Vue.prototype.$listarDadosdoCidadaos = async () => {
  try {
    let res = await axios.get('cidadaos', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

// busca somente um cidadao 
Vue.prototype.$buscarUmCidadao = async (uuid) => {
  try {
    let res = await axios.get('cidadao/1/usuario/'+uuid, {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$telefoneGet = async (uuid) => {
  try {
    let res = await axios.get('listar/telefone/'+uuid, {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$telefoneEdit = async (uuid,telefone,tipo) => {
  try {
    if(tipo == 'Fixo'){
      let res = await axios.put('cidadao/'+uuid+'/telefone/alterar', {
        telefone: telefone,
        tipo:tipo,
      });
      return res.data;
    }else if(tipo == 'Celular'){
      let res = await axios.put('cidadao/'+uuid+'/telefone/alterar', {
        celular: telefone,
        tipo:tipo,
      });
      return res.data;
    }
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$cidadaoEdit = async (uuid,cidadao,usuario) => {
  try {
    let res = await axios.put('cidadaos/'+uuid, { 
        senha:cidadao.senha,
        nome: cidadao.nome,
        tipo_usuario:"Sistema",
        cpf:cidadao.cpf,
        cnpj:cidadao.cnpj,
        usuario:usuario,
        tipo:cidadao.tipo,
        email:cidadao.email,
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}

//editar status cidadao
Vue.prototype.$cidadaoEditStatus = async (uuid,valor,usuario) => {
  try {
    let res = await axios.put('cidadaos/'+uuid, {
        tipo_usuario:"Sistema",
        usuario:usuario,
        status:valor,
    });
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$enderecoGet = async (uuid) => {
  try {
    let res = await axios.get('listar/endereco/'+uuid,{
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}


Vue.prototype.$enderecoEdit = async (uuid,cidadao) => {
  try {
    let res = await axios.put('cidadao/'+uuid+'/endereco/alterar', {
      rua: cidadao.rua,
      numero: cidadao.numero,
      bairro: cidadao.bairro,
      complemento: cidadao.complemento,
      cep: cidadao.cep,
      estado: cidadao.estado,
    });
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

Vue.prototype.$cidadaoDelete = async (uuid,usuario) => {
  try {
    let res = await axios.delete('cidadaos/delete/'+uuid+'/usuario/'+usuario, {
    });
  } catch (e) {
    console.log(e);
  }
}
